export enum BinaryFileLinkRel {
	DOWNLOAD = 'download',
}
